import { JDE_ENVIRONMENTS } from '@centric-os/types';
import type { Config } from '@compassdigital/sdk.typescript/interface/config';

/**
 * Provides utility functions related to JDE environment determination.
 *
 * @returns {{
 *   determineJdeEnvironment: (jdeConfig: JdeConfig, businessUnit: number) => string | null
 * }}
 */
export default () => {
  /**
   * Determines the JDE environment for a given business unit.
   *
   * @param {JdeConfig} Config - The JDE configuration containing staging and production unit lists
   * @param {number} businessUnit - The business unit ID to check
   * @returns {string | null} The determined JDE environment or null if not found
   */
  const determineJdeEnvironment = (jdeConfig: Config, businessUnit: number): string | null => {
    if (!jdeConfig || !businessUnit) return null;

    const isInStaging = jdeConfig?.staging?.units?.includes(businessUnit);
    const isInProduction = jdeConfig?.v1?.units?.includes(businessUnit);

    if (isInStaging && isInProduction) {
      return JDE_ENVIRONMENTS.PY_AND_PRODUCTION;
    }

    if (isInStaging) {
      return JDE_ENVIRONMENTS.PY;
    }

    if (isInProduction) {
      return JDE_ENVIRONMENTS.PRODUCTION;
    }

    return null;
  };

  return {
    determineJdeEnvironment,
  };
};
